import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { IconButton, tokens } from '@hotjar/hotsauce';

const ArrowButton = styled(IconButton)`
  margin: 0 -${tokens.spacer.x6};
`;

interface ArrowProps {
  direction?: 'left' | 'right';
  onClick: () => void;
  isDisabled: boolean;
}

export const Arrow = ({ direction = 'left', onClick, isDisabled }: ArrowProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <ArrowButton
      kind="ghost"
      icon={direction === 'left' ? 'arrow_left_alone' : 'arrow_right_alone'}
      onClick={onClick}
      tooltipText={
        direction === 'left'
          ? t('integrations:details.carousel.previous')
          : t('integrations:details.carousel.next')
      }
      isDisabled={isDisabled}
    />
  );
};
